import { loadPersistedBranding } from "./interfaces";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";

export default {
  namespaced: true,
  state: loadPersistedBranding,
  getters: getters,
  mutations: mutations,
  actions: actions
};
